import { Box, Button, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import axios from "axios";
import moment from "moment";
import { rem, numberFormat } from "assets/js/common";
import ReceiptDrawer from "../../components/receipt/receiptdrawer";
import Loading from "components/ui/loading";
import { Cookies } from "react-cookie";
import { useHistory } from "react-router-dom";

function Mypage() {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const [userReceiptInfo, setUserReceiptInfo] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [usercp, setUsercp] = useState({});
  const [receiptDetail, setReceiptDetail] = useState("");
  const [drawerFull, setDrawerFull] = useState(false);
  const [mystore, setMyStore] = useState("");
  const [fetching, setFetching] = useState(false);
  const [barcodeNum, setBarcodeNum] = useState("");
  const [storeCode, setStoreCode] = useState("");
  const cookies = new Cookies();
  let favInfo = cookies.get("favInfo");
  const history = useHistory();

  const loadUserInfo = async () => {
    await axios.get("api/mb/member/my-info").then((res) => {
      setUserInfo(res.data.data.member);
      console.log(res.data.data);
    });
  };

  const loadUserReceiptInfo = async () => {
    await axios
      .get("api/mb/mypage", {
        params: {
          schTp: favInfo ? favInfo.visibleTp : "1",
          storeCode: favInfo
            ? favInfo.visibleTp === "1"
              ? favInfo.favMt
              : favInfo.favMk
            : "",
        },
      })
      .then((res) => {
        setUserReceiptInfo(res.data.data.receiptList);
        setUsercp(res.data.data);
      })
      .catch((err) => {
        setFetching(false);
      });
  };

  const loadReceiptDetail = (data) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/mb/receipt/get", {
          params: {
            saleDate: data.saleDate,
            storeCode: data.storeCode,
            posNo: data.posId,
            tranNo: data.tranId,
          },
        })
        .then((res) => {
          setBarcodeNum(data.saleDate + data.posId + data.tranId);
          setStoreCode(data.storeCode);
          // setReceiptDetail(
          //   `[등 록] 2022/02/15(화) 10:56 POS No:0101\r\n거래번호:6397  총    4개 판매원:박저희  \r\n----------------------------------------\r\n상품명              단가  수량      금액\r\n----------------------------------------\r\n01 고품격불가리스플레인                 \r\n   8801069217987   4,980    1      4,980\r\n02 하우즈데코)종이컵                    \r\n   8809436053411   1,100    1      1,100\r\n03 신형부직포장바구니                   \r\n   13408572          500    1        500\r\n04#목장신선우유                         \r\n   8801115114260   3,300    1      3,300\r\n상품명앞 \"#\"은 면세 \"*\"는 위수탁 입니다.\r\n\u001b|2C합 계       9,880 원\u001b|1C\r\n----------------------------------------\r\n받 을 돈                        9,880 원\r\n\r\nKB국민체크카드                  9,880 원\r\n카드번호(IC)        5272-89**-****-8302 \r\n할부                        [  0 개월 ]\r\n승인번호                    30025852    \r\n--------<  판  매  영  수  증  >--------\r\n000 (주)메가 607-85-13185  대표:김경조  \r\n합  계:     9,880원  과세품:     5,982원\r\n면세품:     3,300원  부가세:       598원\r\n\r\n▶반품은 구매하신일로 7일 이내 가능\r\n (농산/수산/축산물,냉장/냉동상품/\r\n 베이커리/도서제품은 당일만 가능)\r\n 교환,반품시 사은품은 반환 必       \r\n▶포인트 적립은 30일 이내 가능\r\n▶메가마트 동래점은 정부시책으로 인해   \r\n  매월 둘째,넷째 일요일 휴무실시하며    \r\n  영업시간은  오전 8시부터 ~ 03시까지\r\n거래바코드출력\r\n`
          // );
          setReceiptDetail(res.data.data);
          setDrawerFull(true);
          resolve(true);
        })
        .catch((err) => {
          setFetching(false);
        });
    });
  };

  const loadMyStore = () => {
    axios
      .get("/api/sm/store/my-store", {})
      .then((res) => {
        if (favInfo.visibleTp === "1") {
          setMyStore(res.data.data.mtStore);
        } else if (favInfo.visibleTp === "2") {
          setMyStore(res.data.data.mkStore);
        }
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  window.appBackKeyHandle = () => {
    if (drawerFull) {
      handleCancel();
    } else {
      history.goBack();
    }
  };
  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "마이페이지", menu: true }));
  }, [init]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setFetching(true);
    loadUserInfo();
    loadUserReceiptInfo();
    loadMyStore();
  }, []);

  const handleSelected = async (receipt) => {
    await loadReceiptDetail(receipt);
  };

  const handleCancel = () => {
    setDrawerFull(false);
  };

  return (
    <>
      <Loading open={fetching} />
      <main id="main" className={"container nopad"}>
        <div className="setting">
          <Box className="regularstore">
            <div className="namebox">
              <p>
                <b>{userInfo.nm}</b>님
              </p>
            </div>
            <div className="storebox">
              {!mystore ? (
                <Link
                  to={{
                    pathname: "/favorite-store",
                  }}
                  state={{
                    tp: favInfo,
                  }}
                >
                  <div className="graybox storebox-banner">
                    <div className="boxtext">
                      <p className="tit">단골매장</p>
                      <span className="mega-store">매장을 등록해주세요</span>
                    </div>
                    <Box className="illust">
                      <img
                        src={`${
                          process.env.PUBLIC_URL
                        }/images/icon/illust2.svg`}
                      />
                    </Box>
                  </div>
                </Link>
              ) : (
                <Link to={`/favorite-store/detail/${mystore.cd}`}>
                  <div className="redbox storebox-banner">
                    <div className="boxtext">
                      <p className="tit">단골매장</p>
                      <span className="mega-store">
                        {mystore.tp === "1" ? "메가마트" : "메가마켓"}{" "}
                        {mystore.nm}
                      </span>
                      <p className="time">
                        <b>영업 시간</b> {mystore.formatStrtTm} ~{" "}
                        {mystore.tmTp === "1" ? "당일" : "익일"}{" "}
                        {mystore.formatEndTm}
                      </p>
                    </div>
                    <Box className="illust">
                      <img
                        src={`${
                          process.env.PUBLIC_URL
                        }/images/icon/illust3.svg`}
                      />
                    </Box>
                  </div>
                </Link>
              )}
            </div>
            <div className="cpbox">
              <Link to={"/coupon"} className="coupon">
                <img src={`${process.env.PUBLIC_URL}/images/icon/coupon.svg`} />
                <p className="p1">쿠폰</p>
                <p className="p2">
                  <b>{usercp.couponCnt}</b> 개
                </p>
              </Link>
              {/* <img src={`${process.env.PUBLIC_URL}/images/icon/line.svg`} /> */}
              <Link to={"/point"} className="point">
                <img src={`${process.env.PUBLIC_URL}/images/icon/point.svg`} />
                <p className="p1">포인트</p>
                <p className="p2">
                  <b>{numberFormat(usercp.point)}</b> P
                </p>
              </Link>
            </div>
          </Box>
          <Divider className="divider-type-2" />
          <Box className="my-receipt">
            <Link to={"/receipt"} className="receipt-link">
              <h3>영수증</h3>
            </Link>
          </Box>
          {userReceiptInfo.length > 0 ? (
            <Box className="receipt-three">
              <ul>
                {userReceiptInfo.map((user, index) => (
                  <li key={index} onClick={() => handleSelected(user)}>
                    <div className="a">
                      <div>
                        <p className="date">
                          {moment(user.saleDate).format("YYYY.MM.DD")}
                        </p>
                        <p className="price">
                          {user.saleAmount.toLocaleString()}원
                        </p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </Box>
          ) : (
            <div
              className="nodata"
              style={{ height: "auto", padding: "30px 0 60px" }}
            >
              <Box className="illust">
                <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
              </Box>
              <p className="color-info">
                최근 6개월간 발급된
                <br /> 영수증이 없습니다
              </p>
            </div>
          )}
          <Divider className="divider-type-2" />
          <Box className="mypagelist">
            <ul>
              <li>
                <Link to={"/my-review"} className="">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/menu_my.svg`}
                  />
                  <div>
                    <b className="tit">MY 리뷰</b>
                    <p className="color-info">리뷰 남기고 포인트를 받으세요!</p>
                  </div>
                </Link>
              </li>
              <li>
                <Link to={"/membership"} className="">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/Frame36.svg`}
                  />
                  <div>
                    <b>MY 클럽</b>
                    <p className="color-info">클럽 가입하면 더 많은 혜택이!</p>
                  </div>
                </Link>
              </li>
            </ul>
          </Box>
          <Divider className="divider-type-2" />
          <Box className="box-type-9" style={{ paddingTop: rem(40) }}>
            <ul className="setting-list">
              <li>
                <Link to={"/mypage/shopping"}>
                  <b className="tit" style={{ paddingTop: 0 }}>
                    쇼핑정보 관리
                  </b>
                </Link>
              </li>
              <li>
                <Link to={"/mypage/privacy"}>
                  <b className="tit" style={{ paddingTop: 0 }}>
                    개인정보 수정
                  </b>
                </Link>
              </li>
            </ul>
          </Box>
        </div>
        <ReceiptDrawer
          drawerFull={drawerFull}
          receiptDetail={receiptDetail}
          handleCancel={handleCancel}
          barcodeNum={barcodeNum}
          storeCode={storeCode}
        />
      </main>
    </>
  );
}

export default Mypage;
